import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductsService } from '../../../../../services/products.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-product-add-edit',
  templateUrl: './product-add-edit.component.html',
  styleUrls: ['./product-add-edit.component.scss'],
})
export class ProductAddEditComponent implements OnInit {
  @Input() product: any = {};
  @Output() update = new EventEmitter();

  public isPOSSKU : boolean = false;
  public editingProduct = false;
  public vatInclusive = false;
  public vatRate = 0.0;
  public editingSKU = false;
  public skuExists = false;
  public loading = false;
  public saving = false;
  public currencySymbol = '';
  public currencyoptions: any = {
    prefix: '',
  };

  constructor(
    private productsService: ProductsService,
    private helpersService: HelpersService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
  ) {}

  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  debounceTime = 250;

  ngOnInit() {
    this.isPOSSKU = this.helpersService.getPartnerData().POSSystemID > 0;
    this.vatInclusive = this.helpersService.getPartnerData().VATInclusive;
    this.vatRate = this.helpersService.getPartnerData().VATRate * 100;
    this.currencySymbol =
      this.helpersService.getPartnerData().CurrencySymbol + ' ';
    this.editingProduct = this.product && this.product.id;
    this.currencyoptions.prefix = this.currencySymbol;
    if (this.editingProduct) {
      this.loading = true;
      this.productsService.getSingleProduct(this.product.id).subscribe(
        (data) => {
          this.product = data;
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
    }

    this.subscription = this.modelChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe(() => {
        this.searchProducts();
      });
  }

  inputChanged() {
    this.modelChanged.next('');
  }

  searchProducts() {
    this.productsService
      .checkSKUExists({
        SKU: this.product.sku,
        PartnerID: this.helpersService.getPartnerId(),
        ProductID: this.product.id,
      })
      .subscribe(
        (result) => {
          this.skuExists = true;
        },
        (err) => {
          this.skuExists = false;
        },
      );
  }

  valid() {
    return !!(
      !this.skuExists &&
      this.product.name &&
      this.product.name.length > 0 &&
      this.product.defaultPrice !== null &&
      this.product.defaultPrice !== undefined &&
      this.product.defaultPrice.toString().length > 0
    );
  }

  save() {
    this.saving = true;
    if (this.product.id) {
      this.updateProduct();
    } else {
      this.addProduct();
    }
  }

  addProduct() {
    if( this.isPOSSKU) {
      this.createPOSSKU();
      return;
    }

    var data = {
      ...this.product,
      partnerID: this.helpersService.getPartnerId(),
    };

    this.productsService.createSingleProduct(data).subscribe(
      (res) => {
        this.saving = false;
        this.update.emit(res);
      },
      (err) => {
        this.saving = false;
      },
    );
  }

  createPOSSKU(){
    var data = {
      ...this.product,
      partnerID: this.helpersService.getPartnerId(),
    }
    if(this.helpersService.getPartnerData().VATInclusive) {
      data.UnitPrice_IncludingTax = this.product.defaultPrice;
    }else{
      data.UnitPrice = this.product.defaultPrice;
    }
    console.log(data)

    this.productsService.createPOSSKU(this.helpersService.getPartnerId(), data).subscribe(
      (res) => {
        this.saving = false;
        this.update.emit(res);
      },
      (err) => {
        this.saving = false;
      },
    );

  }

  updateProduct() {
    var data = {
      ...this.product,
    };

    this.productsService.updateSingleProduct(data).subscribe(
      (res) => {
        this.saving = false;
        this.update.emit(res);
      },
      (err) => {
        this.saving = false;
      },
    );
  }

  deleteProduct() {
    this.confirmationService.confirm({
      key: 'add_edit_products',
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      header: this.translate.instant('general.confirm'),
      message: this.translate.instant('bikeshop.products.delete_confirm'),
      accept: () => {
        this.saving = true;
        this.productsService.deleteSingleProduct(this.product.id).subscribe(
          (res) => {
            this.update.emit({ deleted: true, id: this.product.id });
            this.saving = false;
          },
          (err) => {
            this.saving = false;
          },
        );
      },
    });
  }
}
